<script>
    import { onMount } from "svelte";
    import { Paper } from "@svelteuidev/core";
    import DropDownDb from "../../componentes_basicos/DropDownDB.svelte";
    import Constantes from "../../Classes/Constantes";
    import CaixaDeDialogo from "../../componentes_basicos/CaixaDeDialogo.svelte";
    import Conexoes from "../../Classes/Conexoes";
    import consolar from "../../Classes/Consolar";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import { DadosLogin } from "../../Classes/Stores";
    import TelasAcessoNaoAutorizado from "./TelasAcessoNaoAutorizado.svelte";
    import Navigate from "../../Classes/Navigate";
    let id_assessoria =$DadosLogin.id_assessoria;
    let Navi = new Navigate();
    const conexao = new Conexoes();
    let treinos = [
        {
            tipo: "",
            medida: "tempo",
            valor: "",
            unidade: "m",
            zona: "",
        },
    ];
    export let params;
    let id = params;
    let dados = [];
    let message;
    let nomeTreino = "";
    let observacoes = "";
    let config_dp_treino = {
        api: Constantes.api_consultar_padrao,
        parametros: {
            query_code: Constantes.query_code_consulta_livre,
            tabela: "tipo_intervalo_treino_corrida",
        },
        nome_coluna_opcoes: "tipo",
        nome_coluna_saida: "id",
        filtravel: false,
        itens: "",
    };
    let config_dp_intensidade = {
        api: Constantes.api_consultar_padrao,
        parametros: {
            query_code: Constantes.query_code_consulta_livre,
            tabela: "tipo_zonas_corrida",
        },
        nome_coluna_opcoes: "zonas",
        nome_coluna_saida: "id",
        filtravel: false,
        itens: "",
    };

    let carregando = true;
    let isLoading = false;
    let id_assessoriaDoTreino;
    async function PegaDados() {
        if (!id) {
            carregando = false;
            return;
        }
        isLoading = true;
        const resultado = await conexao.conecta(
            Constantes.api_consultar_padrao,
            {
                id: id,
                id_assessoria:id_assessoria, 
                query_code: "consulta_intervalos_de_um_treino",
            },
        );
        treinos = [];
        if (resultado && resultado.length > 0) {
            dados = resultado[0];
            nomeTreino = dados.nome_treino || "";
            observacoes = dados.observacao || "";
            id_assessoriaDoTreino = dados.id_assessoria || "";
            resultado.forEach((element) => {
                treinos.push({
                    tipo: element.tipo || "",
                    medida: element.medida || "",
                    valor: element.valor || "",
                    unidade: element.unidade || "",
                    zona: element.zonas || "",
                });
            });
        } else {
            message = Constantes.msg_erro_conexao_bd;
        }
        console.log("treinos", treinos);
        isLoading = false;
        carregando = false;
    }

    function adicionarIntervalo() {
        treinos = [
            ...treinos,
            {
                tipo: "",
                medida: "tempo",
                valor: "",
                unidade: "m",
                zona: "",
            },
        ];
    }

    function removerIntervalo(index) {
        treinos = treinos.filter((_, idx) => idx !== index);
    }

    async function salvarTreino() {
        if (!nomeTreino.trim()) {
            message = "Por favor, preencha o nome do treino.";
            return;
        }

        for (let i = 0; i < treinos.length; i++) {
            const treino = treinos[i];
            if (
                !treino.tipo ||
                (treino.medida === "distancia" && !treino.unidade) ||
                !treino.zona
            ) {
                message =
                    "Por favor, preencha todos os campos obrigatórios para todos os intervalos.";
                return;
            }
        }

        const dadosTreino = {
            nome_treino: nomeTreino,
            id_assessoria: id_assessoria,
            observacoes: observacoes,
            intervalos: treinos,
        };
        consolar.log(dadosTreino);
        isLoading = true;
        const result = await conexao.conecta(
            Constantes.api_cria_treino_corrida,
            dadosTreino,
        );
        if (result && result.sucesso) {
            message = Constantes.msg_inserido_sucesso;
        } else {
            message = Constantes.msg_erro_conexao_bd;
        }
        isLoading = false;
    }
    async function DeletarTreino() {
        isLoading = true;
        const result = await conexao.conecta(
            Constantes.api_consultar_sem_retorno,
            {
                id: id,
                id_assessoria: id_assessoria,
                query_code: "apaga_tipo_treino",
            },
        );
        if (result && result.executou) {
            message = Constantes.msg_apagados_sucesso;
        } else {
            message = Constantes.msg_erro_conexao_bd;
        }
        isLoading = false;
    }

    onMount(() => {
        PegaDados();
    });
</script>

<LoadingTela {isLoading} />
{#if $DadosLogin.id_assessoria && $DadosLogin.id_assessoria > 0}
    {#if !carregando}
        <CaixaDeDialogo {message} on:close={() =>{ if (message==Constantes.msg_apagados_sucesso || message == Constantes.msg_inserido_sucesso){
          Navi.goTo(Constantes.tela_exibe_lista_treinos)


        }
        
        
        message = "";}



        } />
        
        <div class="container margem">
            <h2>Criar treino</h2>

            <Paper class="mb-3">
                <div class="form-group">
                    <label for="nomeTreino">Nome do treino:</label>
                    <input
                        type="text"
                        id="nomeTreino"
                        class="form-control"
                        bind:value={nomeTreino}
                    />
                </div>
                <div class="form-group">
                    <label for="observacoes">Observações:</label>
                    <input
                        type="text"
                        id="observacoes"
                        class="form-control"
                        bind:value={observacoes}
                    />
                </div>
            </Paper>

            {#each treinos as treino, index}
                <Paper>
                    <div class="d-flex justify-content-end align-items-center">
                        <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            on:click={() => removerIntervalo(index)}
                        >
                            X
                        </button>
                    </div>

                    <div
                        class="d-flex flex-column flex-md-row mb-3"
                        key={index}
                    >
                        <div class="col-md m-2">
                            <label for="tipo">Tipo:</label>
                            <DropDownDb
                                config={config_dp_treino}
                                bind:saida={treino.tipo}
                                class="form-select"
                            />
                        </div>

                        <div class="col-md m-2">
                            <label>Modalidade:</label>
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name={"medida" + index}
                                    id={"tempo" + index}
                                    value="tempo"
                                    bind:group={treino.medida}
                                />
                                <label
                                    class="form-check-label"
                                    for={"tempo" + index}>Tempo</label
                                >
                            </div>

                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name={"medida" + index}
                                    id={"distancia" + index}
                                    value="distancia"
                                    bind:group={treino.medida}
                                />
                                <label
                                    class="form-check-label"
                                    for={"distancia" + index}>Distância</label
                                >
                            </div>
                        </div>

                        <div class="col-md m-2">
                            <label for="valor">Valor:</label>
                            {#if treino.medida === "tempo"}
                                <input
                                    type="time"
                                    id="valor"
                                    class="form-control"
                                    bind:value={treino.valor}
                                />
                            {:else}
                                <input
                                    type="number"
                                    id="valor"
                                    class="form-control"
                                    bind:value={treino.valor}
                                    min="0"
                                />
                            {/if}
                        </div>

                        {#if treino.medida === "distancia"}
                            <div class="col-md m-2">
                                <label>Unidade:</label>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name={"unidade" + index}
                                        id={"m" + index}
                                        value="m"
                                        bind:group={treino.unidade}
                                    />
                                    <label
                                        class="form-check-label"
                                        for={"m" + index}>m</label
                                    >
                                </div>
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name={"unidade" + index}
                                        id={"km" + index}
                                        value="km"
                                        bind:group={treino.unidade}
                                    />
                                    <label
                                        class="form-check-label"
                                        for={"km" + index}>km</label
                                    >
                                </div>
                            </div>
                        {/if}

                        <div class="col-md m-2">
                            <label for="zona">Intensidade:</label>

                            {#if !id}
                                <DropDownDb
                                    config={config_dp_intensidade}
                                    bind:saida={treino.zona}
                                    class="form-select"
                                />
                            {:else}
                                <DropDownDb
                                    config={config_dp_intensidade}
                                    saida={treino.zona}
                                    on:retorno_edicao={(e) =>
                                        (treino.zona = e.detail)}
                                />
                            {/if}
                        </div>
                    </div>
                </Paper>
                <br />
            {/each}

            <div class="text-center">
                <button
                    type="button"
                    class="btn btn-secondary m-3"
                    on:click={adicionarIntervalo}
                >
                    Adicionar Intervalo
                </button>
                {#if id && id_assessoriaDoTreino && id_assessoriaDoTreino!='0'}
                    <button
                        type="button"
                        class="btn btn-danger m-3"
                        on:click={DeletarTreino}
                    >
                        Deletar Treino
                    </button>
                {/if}
                <button
                    type="button"
                    class="btn btn-primary m-3"
                    on:click={salvarTreino}
                >
                    Salvar Novo Treino
                </button>
            </div>
        </div>
    {:else}
        <p>Carregando dados...</p>
    {/if}
{:else}
    <TelasAcessoNaoAutorizado />
{/if}

<style>
    .form-check-label {
        margin-left: 0.5em;
    }
    .form-check-input {
        margin-left: 0.5em;
    }

    .margem {
        margin-top: 5em;
        margin-bottom: 5em;
        background-color: #e6e8f3;
    }
</style>
